import React from 'react'
import PropTypes from 'prop-types'

import SearchHeader from './subcomponents/SearchHeader/SearchHeader'
import SearchPageSkeleton from './SearchPageSkeleton'
import SearchResults from './subcomponents/SearchResults/SearchResults'

const SearchPage = ({ results, onSearch, isLoading }) => {
  return (
    <SearchPageSkeleton
      headerSection={
        <SearchHeader
          results={results}
          onSearch={onSearch}
          isLoading={isLoading}
        />
      }
      listSection={<SearchResults results={results} isLoading={isLoading} />}
    />
  )
}

SearchPage.propTypes = {
  results: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default SearchPage
